import * as types from './types';

const getFormValues = payload => {
  const module = payload.module ? `/MODULE_${payload.module}/${payload.postingId}` : '';
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicador',
      path: `/publicador/api/v1/postings/${payload.step}${module}`,
      method: 'GET'
    }
  };
};

export { getFormValues };
